export default "__VITE_ASSET__gDVdloMb__"